import {createReducer, on} from '@ngrx/store';
import {Transaction} from '../../models/transaction';
import {GetTransactionsSuccess} from '../actions/transactions.actions';

const initialTransactionsState: { list: Array<Transaction>; total: number } = null;

export const transactionsReducer = createReducer(
    initialTransactionsState,
    on(GetTransactionsSuccess, (state, action) => {
        return Object.assign({}, { list: action.list, total: action.total });
    })
);
